/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
const apiNames = Object.freeze({
  REGISTER_PAGE_OVERLAY: "registerPageOverlay",
  COMMENTS: "comments",
  HUD: "hud",
  DOC_EVENTS: "documentEvents",
  DOC_ACTIONS: "documentActions",
  DOC_STATE: "documentState",
  MODIFY_CURSOR: "modifyCursor",
  MODE_CHANGE: "modeChange",
  MODIFY_BACKGROUND_COLOR: "modifyBgColor",
  PREVIEW: "preview",
  CONTEXT_MENU: "contextMenu",
  DISABLE_CONTEXT_MENU: "disableContextMenu",
  REUSABLE_COMPONENTS: "reusableComponents",
  PAGE_VIEW: "pageView",
  DOCUMENT: "document",
  PERSONAL_COMMENTING: "personalCommenting",
  ENABLE_FREETEXT: "enableFreetext",
  TOPBAR: "topBar",
  COMMAND_MANAGER: "commandManager",
  IS_INTEGRATION_CONTEXT: "integrationContext",
  ACROFORM: "acroform"
});

export { apiNames };
